import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUser from 'src/hook/data/useUser';
import { IconLocation } from '../../../../utils/URLUtils';
import Divider from '../../../ui/GlobalComponents/Divider/Divider';
import styles from './BasicSection.module.scss';
import useProgress from 'src/hook/data/useProgress';
import { UserFields } from 'src/model/enum/dataEnums';

interface BasicSectionProps {
  thick?: boolean;
}

const BasicSection = ({ thick }: BasicSectionProps) => {
  const { t } = useTranslation();
  const { userInfo, isWordUpUser } = useUser();
  const [Basic, setBasic] = useState<boolean>(userInfo?.ForceToBasic || false);
  const { updateUserInfoField } = useProgress();

  const handleBasic = (value: boolean) => {
    setBasic(value);
    updateUserInfoField(UserFields.ForceToBasic, value);
  };

  if (!isWordUpUser()) return null;

  return (
    <>
      <div className={styles.section}>
        <div className={styles.row}>
          <img className={styles.icon} src={IconLocation('user-check')} alt={t('Basic')} />
          <span className={styles.text}>{t('Become Basic')}</span>
        </div>
        <div className={styles.switch}>
          <div
            className={Basic ? styles.activeGray : styles.notActive}
            onClick={() => handleBasic(true)}>
            <span>{t('Off')}</span>
          </div>
          <div
            className={!Basic ? styles.active : styles.notActive}
            onClick={() => handleBasic(false)}>
            <span>{t('On')}</span>
          </div>
        </div>
      </div>
      <Divider thick={thick} />
    </>
  );
};

export default BasicSection;